import React from 'react';
import { Field } from 'react-final-form';
import { Checkbox } from 'final-form-material-ui';
import FormControlLabel from '@material-ui/core/FormControlLabel';

interface ICBoxProps {
  label?: any;
  className?: string;
  input: any;
  meta: any;
  disabled?: boolean;
}

const CBox = ({ label, className, input, meta, ...rest }: ICBoxProps) => (
  <FormControlLabel
    className={className}
    control={<Checkbox {...input} {...rest} />}
    label={label}
  />
);

interface ICheckboxProps {
  label?: any;
  name: string;
  validate?: any;
  className?: any;
  disabled?: boolean;
}

const CheckboxField = (props: ICheckboxProps) => (
  <Field
    name={props.name}
    type="checkbox"
    validate={props.validate}
  >
    {(fieldProps) => (
      <CBox
        {...fieldProps}
        label={props.label}
        className={props.className}
        disabled={props.disabled}
      />
    )}
  </Field>
);

export default CheckboxField;